<template>
  <div class="stratcomponent">
    <div v-loading="loading" class="stratstablecontainer">
      <div class="stratstable-export">
        <div class="brains-btn-download" @click="downloadGenericTable('stratstable' + _uid)">{{ $t('export') }} <font-awesome-icon icon="download" /></div>
      </div>
      <table v-if="item!==null" id="scopetableK" class="stratstable" :class="'stratstable' + _uid" style="display: none;" cellspacing="0" role="presentation" aria-describedby="stratscomparetable">
        <tbody>
          <tr class="trstratstitle">
            <td colspan="15"><span class="stratstitle"> {{ $t('stratsData.valuation-by') }} {{ item.groupname }}</span></td>
          </tr>
          <tr class="trstratssubtitle">
            <td colspan="4" class="tdstratssubtitle1"><span class="stratssubtitle1">{{ $t('stratsData.total-value-in') }} {{ item.groupunits }} €</span></td>
            <td colspan="2" class="tdstratssubtitle2"><span class="stratssubtitle2">{{ $t('stratsData.total-value') }}</span></td>
            <td colspan="2" class="tdstratssubtitle3"><span class="stratssubtitle3">{{ $t('stratsData.value-unit') }}</span></td>
            <td colspan="2" class="tdstratssubtitle4"><span class="stratssubtitle4">{{ $t('stratsData.value-sqm') }}</span></td>
            <td colspan="3" class="tdstratssubtitle5" />
          </tr>
          <tr class="trstratsheaders">
            <td class="tdstratsheaders1" />
            <td class="tdstratsheaders2" @click="orderTableBy('units')">
              <span class="stratsheader2">
                #
                <span class="filter-icon-comps">
                  <font-awesome-icon v-if="orderedby !== 'units' && orderedby !== 'units_desc'" icon="sort" />
                  <font-awesome-icon v-if="orderedby === 'units'" class="filter-icon-comps--selected" icon="sort-up" />
                  <font-awesome-icon v-if="orderedby === 'units_desc'" class="filter-icon-comps--selected" icon="sort-down" />
                </span>
              </span>
            </td>
            <td class="tdstratsheaders3" @click="orderTableBy('sqm')">
              <span class="stratsheader3">
                {{ $t('valuationFilters.sqm-cap') }}
                <span class="filter-icon-comps">
                  <font-awesome-icon v-if="orderedby !== 'sqm' && orderedby !== 'sqm_desc'" icon="sort" />
                  <font-awesome-icon v-if="orderedby === 'sqm'" class="filter-icon-comps--selected" icon="sort-up" />
                  <font-awesome-icon v-if="orderedby === 'sqm_desc'" class="filter-icon-comps--selected" icon="sort-down" />
                </span>
              </span>
            </td>
            <td class="tdstratsheaders4" @click="orderTableBy('avgsqm')">
              <span class="stratsheader4">
                {{ $t('stratsData.avg-sqm') }}
                <span class="filter-icon-comps">
                  <font-awesome-icon v-if="orderedby !== 'avgsqm' && orderedby !== 'avgsqm_desc'" icon="sort" />
                  <font-awesome-icon v-if="orderedby === 'avgsqm'" class="filter-icon-comps--selected" icon="sort-up" />
                  <font-awesome-icon v-if="orderedby === 'avgsqm_desc'" class="filter-icon-comps--selected" icon="sort-down" />
                </span>
              </span>
            </td>
            <td class="tdstratsheaders5" @click="orderTableBy('value1')">
              <span class="stratsheader5">
                {{ groupdata.value1keystr }}
                <span class="filter-icon-comps">
                  <font-awesome-icon v-if="orderedby !== 'value1' && orderedby !== 'value1_desc'" icon="sort" />
                  <font-awesome-icon v-if="orderedby === 'value1'" class="filter-icon-comps--selected" icon="sort-up" />
                  <font-awesome-icon v-if="orderedby === 'value1_desc'" class="filter-icon-comps--selected" icon="sort-down" />
                </span>
              </span>
            </td>
            <td class="tdstratsheaders6" @click="orderTableBy('value2')">
              <span class="stratsheader6">
                {{ groupdata.value2keystr }}
                <span class="filter-icon-comps">
                  <font-awesome-icon v-if="orderedby !== 'value2' && orderedby !== 'value2_desc'" icon="sort" />
                  <font-awesome-icon v-if="orderedby === 'value2'" class="filter-icon-comps--selected" icon="sort-up" />
                  <font-awesome-icon v-if="orderedby === 'value2_desc'" class="filter-icon-comps--selected" icon="sort-down" />
                </span>
              </span>
            </td>
            <!--<td class="tdstratsheaders7"><span class="stratsheader7">{{ groupdata.value3keystr }}</span></td>-->
            <td class="tdstratsheaders8" @click="orderTableBy('value1unit')">
              <span class="stratsheader8">
                {{ groupdata.value1keystr }}
                <span class="filter-icon-comps">
                  <font-awesome-icon v-if="orderedby !== 'value1unit' && orderedby !== 'value1unit_desc'" icon="sort" />
                  <font-awesome-icon v-if="orderedby === 'value1unit'" class="filter-icon-comps--selected" icon="sort-up" />
                  <font-awesome-icon v-if="orderedby === 'value1unit_desc'" class="filter-icon-comps--selected" icon="sort-down" />
                </span>
              </span>
            </td>
            <td class="tdstratsheaders9" @click="orderTableBy('value2unit')">
              <span class="stratsheader9">
                {{ groupdata.value2keystr }}
                <span class="filter-icon-comps">
                  <font-awesome-icon v-if="orderedby !== 'value2unit' && orderedby !== 'value2unit_desc'" icon="sort" />
                  <font-awesome-icon v-if="orderedby === 'value2unit'" class="filter-icon-comps--selected" icon="sort-up" />
                  <font-awesome-icon v-if="orderedby === 'value2unit_desc'" class="filter-icon-comps--selected" icon="sort-down" />
                </span>
              </span>
            </td>
            <!--<td class="tdstratsheaders10"><span class="stratsheader10">{{ groupdata.value3keystr }}</span></td>-->
            <td class="tdstratsheaders11" @click="orderTableBy('value1sqm')">
              <span class="stratsheader11">
                {{ groupdata.value1keystr }}
                <span class="filter-icon-comps">
                  <font-awesome-icon v-if="orderedby !== 'value1sqm' && orderedby !== 'value1sqm_desc'" icon="sort" />
                  <font-awesome-icon v-if="orderedby === 'value1sqm'" class="filter-icon-comps--selected" icon="sort-up" />
                  <font-awesome-icon v-if="orderedby === 'value1sqm_desc'" class="filter-icon-comps--selected" icon="sort-down" />
                </span>
              </span>
            </td>
            <td class="tdstratsheaders12" @click="orderTableBy('value2sqm')">
              <span class="stratsheader12">
                {{ groupdata.value2keystr }}
                <span class="filter-icon-comps">
                  <font-awesome-icon v-if="orderedby !== 'value2sqm' && orderedby !== 'value2sqm_desc'" icon="sort" />
                  <font-awesome-icon v-if="orderedby === 'value2sqm'" class="filter-icon-comps--selected" icon="sort-up" />
                  <font-awesome-icon v-if="orderedby === 'value2sqm_desc'" class="filter-icon-comps--selected" icon="sort-down" />
                </span>
              </span>
            </td>
            <!--<td class="tdstratsheaders13"><span class="stratsheader13">{{ groupdata.value3keystr }}</span></td>-->
            <td class="tdstratsheaders14" @click="orderTableBy('value1percent')">
              <span class="stratsheader14">
                % val1
                <span class="filter-icon-comps">
                  <font-awesome-icon v-if="orderedby !== 'value1percent' && orderedby !== 'value1percent_desc'" icon="sort" />
                  <font-awesome-icon v-if="orderedby === 'value1percent'" class="filter-icon-comps--selected" icon="sort-up" />
                  <font-awesome-icon v-if="orderedby === 'value1percent_desc'" class="filter-icon-comps--selected" icon="sort-down" />
                </span>
              </span>
            </td>
            <td class="tdstratsheaders15" @click="orderTableBy('value2percent')">
              <span class="stratsheader15">
                % val2
                <span class="filter-icon-comps">
                  <font-awesome-icon v-if="orderedby !== 'value2percent' && orderedby !== 'value2percent_desc'" icon="sort" />
                  <font-awesome-icon v-if="orderedby === 'value2percent'" class="filter-icon-comps--selected" icon="sort-up" />
                  <font-awesome-icon v-if="orderedby === 'value2percent_desc'" class="filter-icon-comps--selected" icon="sort-down" />
                </span>
              </span>
            </td>
          </tr>
          <tr v-for="val in orderedTable" :key="val.valuekey" class="trstratsdata ">
            <td class="tdstratsdata1">
              <span class="stratsdata1">{{ val.valuekey }}</span>
            </td>
            <td class="tdstratsdata2">
              <span class="stratsdata2">{{ val.units | numeral('0,0') }}</span>
            </td>
            <td class="tdstratsdata3">
              <span class="stratsdata3">{{ val.sqm | numeral('0,0.[00]') }}</span>
            </td>
            <td class="tdstratsdata4">
              <span class="stratsdata4">{{ val.avgsqm | numeral('0,0.[00]') }}</span>
            </td>
            <td class="tdstratsdata5">
              <span class="stratsdata5">{{ val.value1 | numeral('0,0') }} €</span>
            </td>
            <td class="tdstratsdata6">
              <span class="stratsdata6">{{ val.value2 | numeral('0,0') }} €</span>
            </td>
            <!--
            <td class="tdstratsdata7">
              <span class="stratsdata7">{{ val.value3 | numeral('0,0.0') }} €</span>
            </td>
            -->
            <td class="tdstratsdata8">
              <span class="stratsdata8">{{ val.value1unit | numeral('0,0') }} €</span>
            </td>
            <td class="tdstratsdata9">
              <span class="stratsdata9">{{ val.value2unit | numeral('0,0') }} €</span>
            </td>
            <!--
            <td class="tdstratsdata10">
              <span class="stratsdata10">{{ val.value3unit | numeral('0,0.0') }} €</span>
            </td>
            -->
            <td class="tdstratsdata11">
              <span class="stratsdata11">{{ val.value1sqm | numeral('0,0.[00]') }} €</span>
            </td>
            <td class="tdstratsdata12">
              <span class="stratsdata12">{{ val.value2sqm | numeral('0,0.[00]') }} €</span>
            </td>
            <!--
            <td class="tdstratsdata13">
              <span class="stratsdata13">{{ val.value3sqm | numeral('0,0.0') }} €</span>
            </td>
            -->
            <td class="tdstratsdata14">
              <span class="stratsdata14">{{ val.value1percent | numeral('0,0.[00]') }} %</span>
            </td>
            <td class="tdstratsdata15">
              <span class="stratsdata15">{{ val.value2percent | numeral('0,0.[00]') }} %</span>
            </td>
          </tr>
          <tr class="trstratsdatatotal">
            <td class="tdstratsdata1total">
              <span class="stratsdata1total">{{ $t('total') }}</span>
            </td>
            <td class="tdstratsdata2total">
              <span class="stratsdata2total">{{ item.total.units | numeral('0,0') }}</span>
            </td>
            <td class="tdstratsdata3total">
              <span class="stratsdata3total">{{ item.total.sqm | numeral('0,0.[00]') }}</span>
            </td>
            <td class="tdstratsdata4total">
              <span class="stratsdata4total">{{ item.total.avgsqm | numeral('0,0.[00]') }}</span>
            </td>
            <td class="tdstratsdata5total">
              <span class="stratsdata5total">{{ item.total.value1 | numeral('0,0') }} €</span>
            </td>
            <td class="tdstratsdata6total">
              <span class="stratsdata6total">{{ item.total.value2 | numeral('0,0') }} €</span>
            </td>
            <!--
            <td class="tdstratsdata7total">
              <span class="stratsdata7total">{{ item.total.value3 | numeral('0,0.0') }} €</span>
            </td>
            -->
            <td class="tdstratsdata8total"><span class="stratsdata8total">{{ item.total.value1unit | numeral('0,0') }} €</span></td>
            <td class="tdstratsdata9total"><span class="stratsdata9total">{{ item.total.value2unit | numeral('0,0') }} €</span></td>
            <!--<td class="tdstratsdata10total"><span class="stratsdata10total">{{ item.total.value3unit | numeral('0,0.0') }} €</span></td>-->
            <td class="tdstratsdata11total"><span class="stratsdata11total">{{ item.total.value1sqm | numeral('0,0.[00]') }}</span></td>
            <td class="tdstratsdata12total"><span class="stratsdata12total">{{ item.total.value2sqm | numeral('0,0.[00]') }} €</span></td>
            <!--<td class="tdstratsdata13total"><span class="stratsdata13total">{{ item.total.value3sqm | numeral('0,0.0') }} €</span></td>-->
            <td class="tdstratsdata14total"><span class="stratsdata14total">{{ item.total.value1percent | numeral('0,0.[00]') }} %</span></td>
            <td class="tdstratsdata15total"><span class="stratsdata15total">{{ item.total.value2percent | numeral('0,0.[00]') }} %</span></td>
          </tr><tr />
        </tbody>
      </table>
      <hot-table ref="hotTableStrat" :settings="tablesettings" />
    </div>
  </div>
</template>
<script>
// import { getstrattable, getstrattablefilter } from '@/api/portfoliomap'
import { _ } from 'vue-underscore'

import exportTable from '@/components/mixins/exportTable'
import { mapState } from 'vuex'
import 'handsontable/dist/handsontable.full.css'
import { HotTable } from '@handsontable/vue'
// import Handsontable from 'handsontable'
import { registerAllModules } from 'handsontable/registry'
registerAllModules()
export default {
  components: { HotTable },
  mixins: [exportTable],
  props: ['groupdata'],
  data() {
    return {
      item: null,
      loading: false,
      orderedby: 'value2_desc',
      tablesettings: {
        data: [],
        rowHeaders: false,
        colHeaders: [],
        readOnly: true,
        height: 'auto',
        columnSorting: true,
        contextMenu: ['alignment', 'freeze_column', 'unfreeze_column'],
        manualColumnFreeze: true,
        fixedColumnsLeft: 1,
        licenseKey: 'non-commercial-and-evaluation' // for non-commercial use only
      }
    }
  },
  computed: {
    ...mapState('portfolio', {
      current_filters: (state) => state.current_filters
    }),
    orderedTable: {
      get() {
        var data = this.item.values
        let od = this.orderedby
        if (od.indexOf('_desc') > 0) {
          od = od.replace('_desc', '')
        }
        if (od === 'ID_Order') { data = _.sortBy(data, function(item) { return parseInt(item.ID_Order) }) } else { data = _.sortBy(data, od) }

        if (this.orderedby.indexOf('_desc') > 0) {
          data = data.reverse()
        }
        return data
      }
    }
  },
  created() {
    const vm = this
    vm.$root.$on('filterstrats', (data) => {
      console.log('recive filterstrats')
      vm.loading = true
      vm.$store.dispatch('portfolio/getstrattablefilter', { group: vm.groupdata, filterdata: data }).then(response => {
        vm.item = response
        vm.loading = false
      }).catch(error => {
        // debugger
        vm.loading = false
        console.log('error strats')
        console.log(error)
      })
    })
  },
  mounted() {
    // Se añade el id del portfolio en la primera carga
    this.loadstrats()
  },
  beforeDestroy() {
    // quitamos el emit
    const vm = this
    vm.$root.$off('filterstrats')
  },
  methods: {
    orderTableBy(by, order = '') {
      // this.listassets = _.sortBy(this.currentAssets, by)
      if (by === this.orderedby || order === 'desc') {
        // this.listassets = this.listassets.reverse()
        this.orderedby = by + '_desc'
      } else if (order === '') {
        this.orderedby = by
      }
    },
    loadstrats() {
      const vm = this
      vm.loading = true
      console.log('load strats')
      if (vm.current_filters === null) {
        vm.$store.dispatch('portfolio/getstrattable', vm.groupdata).then(response => {
          vm.item = response
          vm.loadtable()
          vm.loading = false
        }).catch(error => {
          // debugger
          vm.loading = false
          console.log('error strats')
          console.log(error)
        })
      } else {
        vm.$store.dispatch('portfolio/getstrattablefilter', { group: vm.groupdata, filterdata: { filters: vm.current_filters }}).then(response => {
          vm.item = response
          vm.loadtable()
          vm.loading = false
        }).catch(error => {
          // debugger
          vm.loading = false
          console.log('error strats')
          console.log(error)
        })
      }
    },
    loadtable() {
      const vm = this
      const headers = [
        vm.item.groupname,
        vm.$t('units'),
        vm.$t('valuationFilters.sqm-cap'),
        vm.$t('stratsData.avg-sqm'),
        vm.$t('stratsData.total-value') + ' ' + vm.groupdata.value1keystr,
        vm.$t('stratsData.total-value') + ' ' + vm.groupdata.value2keystr,
        vm.$t('stratsData.value-unit') + ' ' + vm.groupdata.value1keystr,
        vm.$t('stratsData.value-unit') + ' ' + vm.groupdata.value2keystr,
        vm.$t('stratsData.value-sqm') + ' ' + vm.groupdata.value1keystr,
        vm.$t('stratsData.value-sqm') + ' ' + vm.groupdata.value2keystr,
        '% ' + vm.groupdata.value1keystr,
        '% ' + vm.groupdata.value2keystr
      ]
      const columns = [
        { data: 'valuekey' },
        { data: 'units' },
        { data: 'sqm' },
        { data: 'avgsqm' },
        { data: 'value1' },
        { data: 'value2' },
        { data: 'value1unit' },
        { data: 'value2unit' },
        { data: 'value1sqm' },
        { data: 'value2sqm' },
        { data: 'value1percent' },
        { data: 'value2percent' }
      ]
      this.tablesettings.columns = columns
      this.tablesettings.colHeaders = headers
      const datastrat = vm.orderedTable
      datastrat.push({
        valuekey: '***' + vm.$t('total') + '***',
        units: vm.item.total.units,
        sqm: vm.item.total.sqm,
        avgsqm: vm.item.total.avgsqm,
        value1: vm.item.total.value1,
        value2: vm.item.total.value2,
        value1unit: vm.item.total.value1unit,
        value2unit: vm.item.total.value2unit,
        value1sqm: vm.item.total.value1sqm,
        value2sqm: vm.item.total.value2sqm,
        value1percent: vm.item.total.value1percent,
        value2percent: vm.item.total.value2percent
      })
      this.tablesettings.data = datastrat

      this.$refs.hotTableStrat.hotInstance.updateSettings(this.tablesettings)
    }
  }
}
</script>

<style scoped lang="scss">
.stratstable-export {
  display: flex;
  align-items: center;
  justify-content: right;
}

.stratstablecontainer {
  min-height: 100px;
}

  .stratstable {
    width: 100%;
    display: none;
}

    .stratstable tr td {
        padding: 0px;
        /*border:1px solid green;*/
    }

.stratstitle {
    font-weight: bold;
    font-size: 1.1em;
}

.trstratstitle {
    border-bottom: 4px solid;
}

.trstratsheaders td {
  border-bottom: 2px solid;
  cursor: pointer;
}
.stratssubtitle1 {
    font-size: 0.8em;
}

.stratssubtitle2, .stratssubtitle3, .stratssubtitle4 {
    font-weight: bold;
    font-size: 0.8em;
}

.tdstratssubtitle2, .tdstratssubtitle3, .tdstratssubtitle4 {
    text-align: center;
    background-image: linear-gradient(black, black 100%);
    background-size: 98% 1px;
    background-repeat: no-repeat;
    background-position: center bottom;
}

.trstratsheaders {
    font-weight: bold;
    font-size: 0.85em;
    border-bottom: 2px solid;
    text-align: center;
}

.trstratsdata {
    font-size: 0.9em;
}

    .trstratsdata td {
        text-align: right;
    }

        .trstratsdata td span {
            padding-right: 10px;
        }

.tdstratsdata1 {
    text-align: left !important;
}

.trstratsdatatotal {
    border-top: 2px solid;
    border-bottom: 2px solid;
    font-weight: bold;
    font-size: 0.9em;
}

    .trstratsdatatotal td {
        text-align: right;
    }

        .trstratsdatatotal td span {
            padding-right: 10px;
        }

.tdstratsdata1total {
    text-align: left !important;
}

.stratstable tbody {
    font-size: 9pt;
}

.trstratstitle {
    border-bottom: 3px solid #1e3cff;
}

.trstratstitle td {
    border-bottom: 3px solid #1e3cff;
}

.trstratsdatatotal td {
    border-bottom: 3px solid #1e3cff;
    border-top: 3px solid #1e3cff;
}

.stratstitle {
    font-size: 1.2em !important;
}

#btnprintstrats i {
    color: black !important;
}

.stratsinternal {
    padding: 15px !important;
}

.stratstable {
    margin-left: 10px !important;
}

    .stratstable tr td {
        line-height: 2;
    }

.trstratsdatatotal {
    border-top: 2px solid #1e3cff !important;
    border-bottom: 2px solid #1e3cff !important;
}

.tdstratssubtitle1 span, .tdstratssubtitle2 span, .tdstratssubtitle3 span, .tdstratssubtitle4 span {
    font-weight: bold;
}
</style>
